import { Value } from '@philips-emr/tws-core';

import BaseFieldAPI from '../field/base-field-api';

class LocatorFieldAPI extends BaseFieldAPI {

  getValue(): Value {
    const data = this.getData();
    const entry = this.getEntry();

    return data[entry];
  }

  setValue(value: Value): void {
    const { entry, data } = this.state;

    const oldValue = data[entry];
    data[entry] = value;

    this.setState({ data });

    this.onChange.fire({ entry, value, oldValue });
  }
}

export default LocatorFieldAPI;
